<script>
	// 빌더 좌측 섹션 네비게이션. 탭 상태는 호출부가 소유 — 여긴 표현만.
	// game-builder/shell/GameBuilderSidebar.svelte 와 같은 규격(레일 56px → 풀 220px)이다.
	import { createEventDispatcher } from "svelte";

	export let tabList = [];
	export let currentTab = "";

	const dispatch = createEventDispatcher();

	const icons = {
		design:
			'<circle cx="13.5" cy="6.5" r=".5"/><circle cx="17.5" cy="10.5" r=".5"/><circle cx="8.5" cy="7.5" r=".5"/><circle cx="6.5" cy="12.5" r=".5"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.9 0 1.6-.7 1.6-1.6 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1a1.6 1.6 0 0 1 1.6-1.6h2c3 0 5.6-2.5 5.6-5.6C22 6 17.5 2 12 2z"/>',
		screen: '<rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/>',
		tile: '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>',
		recipe: '<path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><path d="M8 7h8M8 11h5"/>',
		identity: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>',
		economy: '<circle cx="12" cy="12" r="8"/><path d="M14.5 9.5a2.5 2.5 0 0 0-5 0c0 3 5 1.5 5 4.5a2.5 2.5 0 0 1-5 0"/><line x1="12" x2="12" y1="6" y2="18"/>',
		share: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.6" x2="15.4" y1="13.5" y2="17.5"/><line x1="15.4" x2="8.6" y1="6.5" y2="10.5"/>',
		ops: '<path d="M3 3v18h18"/><path d="M7 15v2"/><path d="M11 11v6"/><path d="M15 7v10"/><path d="M19 12v5"/>',
	};
</script>

<!-- 폰(<md=768px)은 상단 가로 탭으로 대체 → 여기선 숨김.
     태블릿(md~lg)은 아이콘 레일(56px), 데스크톱(≥lg=1024px)은 풀 사이드바(220px). -->
<aside class="tw-hidden tw-w-14 tw-shrink-0 tw-flex-col tw-border-r tw-border-border tw-bg-sidebar tw-font-sans md:tw-flex lg:tw-w-[220px]">
	<nav class="tw-flex tw-flex-1 tw-flex-col tw-gap-1 tw-px-2 tw-pt-4 lg:tw-px-3">
		<div class="tw-hidden tw-px-2 tw-pb-1 tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-wide tw-text-muted-foreground lg:tw-block">
			빌더 단계
		</div>
		{#each tabList as tab (tab.value)}
			<button
				type="button"
				title={tab.label}
				class="tw-flex tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2.5 tw-rounded-lg tw-px-2.5 tw-py-2 tw-text-left tw-text-sm tw-transition-colors lg:tw-justify-start {currentTab ===
				tab.value
					? 'tw-bg-primary/10 tw-font-semibold tw-text-primary'
					: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
				on:click={() => dispatch("change", tab.value)}
			>
				<svg
					class="tw-h-[18px] tw-w-[18px] tw-shrink-0"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"
				>
					{@html icons[tab.value] || ""}
				</svg>
				<span class="tw-hidden tw-flex-1 lg:tw-block">{tab.label}</span>
			</button>
		{/each}
	</nav>
</aside>
